export function getAbsolutePublicAssetUrl(relativePath) {
  const path = (relativePath || "").trim() || "/";
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (typeof window === "undefined" || !window.location?.origin) {
    return normalized;
  }
  const pub = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${window.location.origin}${pub}${normalized}`;
}
